import React, { useEffect, useState, useCallback } from 'react'
import { useIntl } from "react-intl";
//Components
import { useDispatch, useSelector } from 'react-redux';
import Tabs, { TabContainer } from 'Components/Tabs';
import { Button } from 'Components';

//Views
import EtaActive from './components/etaActive'
import EtaScheduled from './components/etaScheduled'
import EtaExpired from './components/etaExpired'
import EtaCreateEdit from './components/etaCreateEdit'
import EtaDelete from './components/etaDelete'
import EtaContacts from './components/etaContacts'
//Enums
import { MapUtilitiesTypes } from 'Modules/realtimeMaps/main/components/MapUtilitiesMenu/enums';
import { TypeLayer } from 'Components/Map/providers/enums';

//Actions
import { selectModuleMapSettings, drawGetDirections, addPointers } from "Redux/actions";
import { etaCreateEditSetField } from './components/etaCreateEdit/redux/slice';
import { etaDeleteOpenModal } from './components/etaDelete/redux/slice';
import { etaReset, realtimeMapsEtaSearchEtaLinks } from './redux/slice';
import { etaCreateEditReset } from './components/etaCreateEdit/redux/slice';

const Eta = (props) => {
    const { mapRef } = props
    const { messages, locale } = useIntl();
    const dispatch = useDispatch();

    //Redux States
    const { create, edit } = useSelector(state => state.realtimeMapEtaLinkCreateEditRedux);
    const { loading, limit, offset } = useSelector(state => state.realtimeMapEtaLinkRedux);
    const { result: deleteEta } = useSelector((state) => state.etaDeleteRedux);
    const createEditEtaOpenModal = useSelector(state => state.realtimeMapEtaLinkCreateEditRedux.open);
    const deleteEtaOpenModal = useSelector((state) => state.etaDeleteRedux.open);
    const contactsEtaOpenModal = useSelector((state) => state.etaContactsRedux.open);

    //Local States
    const [selectedRows, setSelectedRows] = useState([]);
    const [searchText, setSearchText] = useState("");
    const [page, setPage] = useState(0);
    const [tab, setTab] = useState(0);

    useEffect(() => {
        if (create?.id || edit?.id || deleteEta) {
            let currentStatus = handleStatus(tab)
            dispatch(etaReset({ limit: 10, offset: 0 }))
            dispatch(realtimeMapsEtaSearchEtaLinks({ status: currentStatus, openSearch: searchText, limit: 10, offset: 0 }))
        }
    }, [create, edit, deleteEta])

    const getSelectedItems = () => {
        const filterChecked = selectedRows.filter((item) => item.checked == true)
        if (filterChecked && filterChecked.length > 0) return true
        return false
    }

    const handleStatus = (currentTab) => {
        const status = {
            0: ["Active"],
            1: ["Scheduled"],
            2: ["Expired", "Completed"]
        }
        return status[currentTab]
    }

    const handleClose = () => {
        mapRef?.current?.removeLayer(TypeLayer.EtaLinkMarker);
        mapRef?.current?.deleteRouteInMap();
        dispatch(drawGetDirections(false));
        dispatch(addPointers([]));
        dispatch(selectModuleMapSettings(MapUtilitiesTypes.Default));
        setSelectedRows([]);
        setSearchText("");
        dispatch(etaReset())
        setTab(0);
        setPage(0);
    }

    const handleTab = (newTab) => {
        mapRef?.current?.removeLayer(TypeLayer.EtaLinkMarker);
        mapRef?.current?.deleteRouteInMap();
        dispatch(drawGetDirections(false));
        dispatch(addPointers([]));
        setSelectedRows([])
        setSearchText("")
        dispatch(etaReset({ offset: 0, result: [], total: 0, limit: 10 }))
        setTab(newTab)
        setPage(0)
    }

    const onChangePage = useCallback((paramPage) => {
        let currentOffset = paramPage === 1 ? 0 : offset + limit
        dispatch(etaReset({ offset: currentOffset }))
        let currentStatus = handleStatus(tab)
        dispatch(realtimeMapsEtaSearchEtaLinks({ status: currentStatus, openSearch: searchText, limit: 10, offset: currentOffset, newPage: true }))
    });

    const onSearch = (value) => {
        setSearchText(value);
        if (window.typingTime) {
            clearTimeout(window.typingTime);
        }
        window.typingTime = setTimeout(() => {
            let currentStatus = handleStatus(tab)
            dispatch(etaReset({ limit: 10, offset: 0 }))
            dispatch(realtimeMapsEtaSearchEtaLinks({ status: currentStatus, openSearch: value, limit: 10, offset: 0 }))
        }, 1000);
    }

    useEffect(() => {
        return () => {
            dispatch(etaCreateEditReset());
            handleClose()
        }
    }, [])

    return (
        <div style={{ height: '100%' }}>
            <div style={{ display: 'flex', justifyContent: 'end', marginTop: -50 }}>
                {
                    getSelectedItems() &&
                    <Button
                        onClick={() => {
                            let currentList = selectedRows.filter((item) => item.current && item?.checked).map((item) => item?.current)
                            dispatch(etaDeleteOpenModal(currentList))
                        }}
                        tooltip={messages['menu_delete']}
                        type="icon"
                        icon="delete"
                        style={{
                            color: !getSelectedItems() ? '#ABABAB' : '#212121'
                        }}
                    />
                }
                <Button
                    onClick={() => {
                        dispatch(etaCreateEditSetField({ open: true, eta: null }))
                    }}
                    disabled={false}
                    tooltip={messages['menu_add']}
                    type="icon"
                    icon="add_circle"
                />
            </div>
            <Tabs
                tab={tab}
                type="icon-indicator"
                border
                onChange={(tab) => handleTab(tab)}
                disabled={loading}
            >
                <TabContainer
                    style={{ padding: '5px 0px 0px 0px' }}
                    iconIndicator="access_alarm"
                    label={messages['eta_type_active']}
                    index={0}
                >
                    {tab === 0 && (
                        <EtaActive
                            mapRef={mapRef}
                            setSelectedRows={setSelectedRows}
                            selectedRows={selectedRows}
                            searchText={searchText}
                            onSearch={onSearch}
                            onChangePage={onChangePage}
                            page={page}
                            setPage={setPage}
                        />
                    )}
                </TabContainer>
                <TabContainer
                    style={{ padding: '5px 0px 0px 0px' }}
                    iconIndicator="event_available"
                    label={messages['eta_type_scheduled']}
                    index={1}
                >
                    {tab === 1 && (
                        <EtaScheduled
                            mapRef={mapRef}
                            setSelectedRows={setSelectedRows}
                            selectedRows={selectedRows}
                            searchText={searchText}
                            onSearch={onSearch}
                            onChangePage={onChangePage}
                            page={page}
                            setPage={setPage}
                        />
                    )}
                </TabContainer>
                <TabContainer
                    style={{ padding: '5px 0px 0px 0px' }}
                    iconIndicator="alarm_on"
                    label={messages['eta_type_expired']}
                    index={2}
                >
                    {tab === 2 && (
                        <EtaExpired
                            mapRef={mapRef}
                            setSelectedRows={setSelectedRows}
                            selectedRows={selectedRows}
                            searchText={searchText}
                            onSearch={onSearch}
                            onChangePage={onChangePage}
                            page={page}
                            setPage={setPage}
                        />
                    )}
                </TabContainer>
            </Tabs>
            {createEditEtaOpenModal && <EtaCreateEdit mapRef={mapRef} />}
            {deleteEtaOpenModal && <EtaDelete />}
            {contactsEtaOpenModal && <EtaContacts />}
        </div>
    )
}

export default Eta

